<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.welding.filler_material.title')" header-tag="h3" class="bg-default-card">
                    <data-table
                        v-if="tableLoaded"
                        :exportable="this.$store.getters.hasPermission(['project_filler_material'], ['read'])"
                        :importable="true"
                        title=""
                        :rows="getData.rowData"
                        :columns="columnData"
                        :perPage="perPage"
                        :rowsCount="rowsCount"
                        :currentPage="currentPage"
                        :pageCount="pageCount"
                        @exportButtonClick="onExportButton"
                        @rowClickDelete="onDeleteRow"
                        @rowClickEdit="onEditRow"
                        @changePage="changePage"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                        >
                    </data-table>
                    <b-btn class="btn btn-default mt-2" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project_filler_material'], ['create'])"><i class="fa fa-plus-circle mr-1"></i> {{$t('general.welding.filler_material.create_button')}}</b-btn>

                    <span v-if="this.$store.getters.hasPermission(['project_filler_material'], ['create', 'update'])">
                        <label v-if="!this.$store.state.ajax_in_progress" class="btn btn-primary mt-3 ml-2" @click="$refs.importExcel.value = ''">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.welding.filler_material.import_button') }}</span>
                            <input type="file" name="file" style="display:none" ref="importExcel" @change="onImportButton($event.target.name, $event.target.files)" accept="application/*"/>
                        </label>
                        <label v-else class="btn btn-primary mt-3 disabled">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.ajax_in_progress_please_wait') }}</span>
                        </label>
                    </span>
                </b-card>
            </div>
        </div>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="saveModal" id="saveModal" :title="actionTitle" size="lg" @ok="saveAction" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_filler_material'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.type') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.type">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.produced_by') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.produced_by">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.heat_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.heat_no">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.dimension') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.dimension">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.certificate_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.certificate_no">
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.note_1') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.note_1"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.note_2') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.note_2"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <hr v-if="(getData.getFiles.length > 0 && hasFilesReadPermission) || hasFilesCreatePermission">
            <div class="row mt-2" v-if="getData.getFiles.length > 0 && hasFilesReadPermission">
                <div class="col-lg-12">
                    <label>{{ $t('table.uploaded_files') }}</label>
                </div>
                <div class="col-lg-6" v-for="file in getData.getFiles" :key="file.id">
                    <div class="card p-2">
                        <div style="width: 100%; display: block">
                            <p 
                                class="float-left customLink" 
                                @click="onDownloadFile(file.id)" 
                                :title="file.file_name"
                            >
                                {{file.file_name}}
                            </p>
                            <p 
                                v-if="hasFilesDeletePermission"
                                class="float-right p-0 m-0"
                            >
                                <i class='fa fa-2x fa-trash mt-2 text-danger sortable cursor-pointer' @click="onDeleteFile(file.id)"></i>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-2" v-if="hasFilesCreatePermission">
                <div class="col-lg-12">
                    <div class="row mb-3">
                        <div class="col-lg-12">
                            <label v-if="row && getData.getFiles.length > 0">{{ $t('table.upload_more_files') }}</label>
                            <label v-else>{{ $t('table.upload_files') }}</label>
                        </div>
                        <div class="col-lg-12">
                            <vue-dropzone class="dropzone" ref="document" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <confirm-dialog ref="deleteModal" :title="actionTitleDelete" @buttonClick="deleteAction">
            {{ delete_message }}
        </confirm-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import miniToastr from 'mini-toastr';
import http from '@/libs/http';

import Multiselect from 'vue-multiselect';

import vue2Dropzone from 'vue2-dropzone';
import '@/assets/css/vue2Dropzone.css';

export default {
    name: 'filler_material',
    components: {
        DataTable,
        ConfirmDialog,
        Multiselect,
        vueDropzone: vue2Dropzone,
    },
    data() {
         return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/'
                },
                {
                    text: '',
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.welding.title'),
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.welding.filler_material.title'),
                    active: true
                }
            ],
            tableName: 'fillermaterial',
            tableNameTranslated: Vue.i18n.translate('general.welding.filler_material.title_modal'),
            row: null,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            actionTitle: '',
            delete_message: '',
            actionTitleDelete: '',

            file_id: null,
            isFileDelete: false,

            hasFilesReadPermission: false,
            hasFilesCreatePermission: false,
            hasFilesDeletePermission: false,
            
            dropzoneOptions: {
                url: '/',
                thumbnailWidth: 150,
                addRemoveLinks: true,
                autoProcessQueue: false,
                uploadMultiple: true,
                dictDefaultMessage: '<i class="fa fa-cloud-upload"></i>' + ' ' + Vue.i18n.translate('table.upload_files'),
                maxFiles: 3,
            },
            getData: {
                rowData: [],
                getFiles: [],
            },
            model: {
                type: null,
                produced_by: null,
                heat_no: null,
                dimension: null,
                certificate_no: null,
                note_1: null,
                note_2: null,
            },
            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '90px',
                    field: '',
                    showDeleteButton: true,
                    showEditButton: true
                },
                {
                    label: Vue.i18n.translate('table.type'),
                    field: 'type',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.produced_by'),
                    field: 'produced_by',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.heat_no'),
                    field: 'heat_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.dimension'),
                    field: 'dimension',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.certificate_no'),
                    field: 'certificate_no',
                    numeric: false,
                    html: false,
                },
            ]
        }
    },
    mounted() {
        this.onLoadTable();

        this.hasFilesReadPermission   = this.$store.getters.hasPermission(['files'], ['read']);
        this.hasFilesCreatePermission = this.$store.getters.hasPermission(['files'], ['create']);
        this.hasFilesDeletePermission = this.$store.getters.hasPermission(['files'], ['delete']);
    },
    methods: {
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            let data = http.route(this.tableName + '?project_id=' + this.$route.params.id + '&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get();
            data.then(response => {
                if (!response.isError) {
                    this.perPage     = response.pagination.limit;
                    this.rowsCount   = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount   = response.pagination.totalPages;
                    this.getData.rowData = response.data;
                    this.tableLoaded = true;
                    this.breadcrumbItems[1].text = Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        clearSearches () {
            this.getData.getFiles = [];
            this.$nextTick(() => {
                if (typeof this.$refs.document != 'undefined') {
                    this.$refs.document.removeAllFiles();
                }
            });
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.row = null;
            this.clearSearches();

            this.model.type = null;
            this.model.produced_by = null;
            this.model.heat_no = null;
            this.model.dimension = null;
            this.model.certificate_no = null;
            this.model.note_1 = null;
            this.model.note_2 = null;

            this.$refs.saveModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.clearSearches();

            if (this.hasFilesReadPermission) {
                this.onViewFiles(row.id);
            }

            this.model.type = this.row.type;
            this.model.produced_by = this.row.produced_by;
            this.model.heat_no = this.row.heat_no;
            this.model.dimension = this.row.dimension;
            this.model.certificate_no = this.row.certificate_no;
            this.model.note_1 = this.row.note_1;
            this.model.note_2 = this.row.note_2;
            this.$refs.saveModal.show();
        },
        saveAction (e) {
            e.preventDefault();

            let put_data = {
                project_id: this.$route.params.id,
                type: this.model.type,
                produced_by: this.model.produced_by,
                heat_no: this.model.heat_no,
                dimension: this.model.dimension,
                certificate_no: this.model.certificate_no,
                note_1: this.model.note_1,
                note_2: this.model.note_2,
            }

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            if (this.row) {
                let data = http.route(this.tableName + '/' + this.row.id).patch(put_data, true);
                data.then(response => {
                    if(!response.isError) {
                        this.onLoadTable();
                        this.uploadDocuments(this.row.id);
                        this.$refs.saveModal.hide();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            } else {
                let data = http.route(this.tableName).post(put_data, true);
                data.then(response => {
                    if(!response.isError) {
                        this.onLoadTable();
                        this.uploadDocuments(response.data.id);
                        this.$refs.saveModal.hide();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
        uploadDocuments (id) {
            if (this.hasFilesCreatePermission && typeof this.$refs.document != 'undefined') {
                var file = this.$refs.document.getQueuedFiles();
                for (let order = 0; order < file.length; order++) {
                    var formData = new FormData();
                    formData.append('file', file[order]);
                    formData.append('type', 'filler_material');
                    formData.append('filler_material_id', id);
                    formData.append('project_id', this.$route.params.id);
                    let data = http.route('file').post(
                        formData,
                            {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    ).then(response => {
                        if(response.data == false) {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        } else {
                            this.successMsg(Vue.i18n.translate('messages.file_uploaded'));
                            this.onLoadTable();
                        }
                    });
                }
            }
        },
        onViewFiles (id) {
            this.getData.getFiles.length = 0;
            let data = http.route('file?filters[filler_material_id]=' + id).get();
            data.then(response => {
                if(response.data == false) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.getData.getFiles = response.data;
                }
            });
        },
        onDownloadFile (id) {
            let data = http.route('file/' + id).get(
            {
                export_pdf: 1
            }, true);
            data.then(response => {
                if (!response.isError) {
                    this.successMsg(Vue.i18n.translate('messages.file.file_download'));
                    let data = http.route('get_content/file/'+response.data.id+'/'+response.data.file_name).downloadPdf({}, response.data.file_name).then(res => {});
                } else {
                    this.errorMsg(Vue.i18n.translate('messages.file.error_download'));
                }
            });
        },
        onDeleteRow (row) {
            this.actionTitleDelete = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.delete_message = Vue.i18n.translate('messages.delete');
            this.row = row;
            this.file_id = null;
            this.isFileDelete = false;
            this.$refs.deleteModal.show();
        },
        onDeleteFile (id) {
            this.actionTitleDelete = Vue.i18n.translate('messages.delete_file_title');
            this.delete_message = Vue.i18n.translate('messages.delete_file');
            this.file_id = id;
            this.isFileDelete = true;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                if (this.isFileDelete == true) {
                    this.row.file_id = null;
                    let data = http.route('file/' + this.file_id).delete();
                    data.then(response => {
                        if (!response.isError) {
                            this.onLoadTable();
                            this.successMsg(Vue.i18n.translate('messages.deleted_file_message'));
                            this.$refs.saveModal.hide();
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                } else if (this.isFileDelete == false) {
                    let data = http.route(this.tableName + '/' + this.row.id).delete();
                    data.then(response => {
                        if (!response.isError) {
                            if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                                this.currentPage = this.currentPage - 1;
                            }

                            this.onLoadTable();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                }
            }

            this.$refs.deleteModal.hide();
        },
        onExportButton() {
            http.route(this.tableName + '?project_id=' + this.$route.params.id).exportExcel({
                export: 1,
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType
            }, 'filler_material.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.exported'));
                }
            });
        },
        onImportButton(fieldName, fileList) {
            const formData = new FormData();

            if (!fileList.length) return;

            formData.append('project_id', this.$route.params.id);

            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                formData.append(fieldName, fileList[x], fileList[x].name);
            });

            http.route(this.tableName+'/import').importExcel(formData)
            .then(response => {
                if (response.isError) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.onLoadTable();
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.imported'));
                }
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/welding/filler_material/filler_material.vue